import { IFace } from './Face/Face';

export const faces: Array<IFace> = [
  { name: 'Harry Pham', jobTitle: 'Founder and CEO', urlImg: './images/team/Pham.png' },
  { name: 'Bui Cai', jobTitle: 'Co-founder and CTO', urlImg: './images/team/Cai.png' },
  { name: 'Binh Mai', jobTitle: 'Blockchain expert', urlImg: './images/team/Mai.png' },
  { name: 'Lisa Dowen', jobTitle: 'Marketing and funnels', urlImg: './images/team/dowen.png' },
  { name: 'Harry Pham', jobTitle: 'Founder and CEO', urlImg: './images/team/Pham.png' },
  { name: 'Bui Cai', jobTitle: 'Co-founder and CTO', urlImg: './images/team/Cai.png' },
  { name: 'Binh Mai', jobTitle: 'Blockchain expert', urlImg: './images/team/Mai.png' },
  { name: 'Lisa Dowen', jobTitle: 'Marketing and funnels', urlImg: './images/team/dowen.png' },
];
